// extracted by mini-css-extract-plugin
module.exports = {"main":"profile-menu_main__23Dsn","menuItem":"profile-menu_menuItem__37TWh"};